import type { PropsWithChildren } from 'react';

const EmptyContainer = ({ children }: PropsWithChildren<{}>) => {
    return <div className="flex w-full justify-center rounded-xl bg-white sm:p-24">{children}</div>;
};

export default EmptyContainer;
